import { useConfig } from "@/context/ConfigContext";
import { useEffect, useState } from "react";
import { normalizeLandingAdsPayload } from "@/components/landing-content/landingBlocksAdapter";

export function useLandingAds(options = {}) {
  const {
    slug,
    enabled = true,
    initialData = null,
    initialSlug = null,
  } = options;
  const { configData } = useConfig();
  const [landingAds, setLandingAds] = useState(initialData);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!enabled || !slug) {
      setLandingAds(null);
      return;
    }

    if (initialData && initialSlug && String(initialSlug) === String(slug)) {
      setLandingAds(initialData);
      setError(null);
      setLoading(false);
      return;
    }

    if (!configData?.team_id) {
      setLoading(true);
      return;
    }

    const controller = new AbortController();

    const fetchLandingAds = async () => {
      try {
        setLoading(true);
        setError(null);

        const proxyUrl = `/api/landing-ads?team_id=${
          configData.team_id
        }&slug=${encodeURIComponent(slug)}`;
        const response = await fetch(proxyUrl, {
          method: "GET",
          headers: { Accept: "application/json" },
          signal: controller.signal,
        });
        const payload = await response.json().catch(() => null);
        if (!response.ok || (payload?.code && Number(payload.code) !== 200)) {
          throw new Error(payload?.message || "Gagal mengambil landing ads");
        }

        setLandingAds(normalizeLandingAdsPayload(payload?.data || null));
      } catch (err) {
        if (err?.name === "AbortError") return;
        setError(err.message || "Gagal mengambil landing ads");
      } finally {
        if (!controller.signal.aborted) setLoading(false);
      }
    };

    fetchLandingAds();
    return () => controller.abort();
  }, [enabled, slug, configData?.team_id, initialData, initialSlug]);

  return {
    landingAds,
    loading,
    error,
  };
}
